import {request} from "../shared/helper/RequestWrapper";
import {HttpRequest} from "../shared/enums/http.methods.enums";
const GET_WIDGETS_DATA = "/get_widgets_data";

export async function getWidgetsData() {
    return await request({
        endpoint: GET_WIDGETS_DATA,
        method: HttpRequest.GET,
    });
}